package cc.easyandroid.extensions_compose.mvi

import cc.easyandroid.easycompose.mvi.rx.Disposable
import cc.easyandroid.easycompose.mvi.rx.Observer
import cc.easyandroid.easycompose.mvi.rx.observer
import kotlinx.coroutines.channels.awaitClose
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.callbackFlow

internal inline fun <T, R> T.toFlow(
    crossinline subscribe: T.(Observer<R>) -> Disposable,
): Flow<R> =
    callbackFlow {
        val disposable =
            subscribe(
                observer(
                    onComplete = { channel.close() },
                    onNext = { channel.trySend(it) }
                )
            )

        awaitClose(disposable::dispose)
    }
